import * as ActionTypes from './action-types.constants';

export const ready = (BrowserRouter = null) => {
    return {
        type: ActionTypes.READY,
        BrowserRouter
    }
}
export const changeLocation = ( path = "") => {
    return {
        type: ActionTypes.CHANGE_LOCATION,
        path
    }
}
export const historyLocationChange = ( location ) => {
	return {
		type: ActionTypes.HISTORY_LOCATION_CHANGE,
		location
	}
}